
<section id="console_body">
    <aside class="console_sidebar">
        <header class="sidebar_head">
            <span class="head_brand">FADPE</span>
        </header>

        <nav-menu />
    </aside>

    <section class="console_routing">
        <router-outlet />
    </section>
</section>

<toast-notification aria-live="polite" aria-atomic="true" />
